<template>
  <div v-loading="loading" style="padding:15px;" @copy="handleCopy">
    <el-date-picker
      v-model="daterange"
      type="daterange"
      size="mini"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      :picker-options="pickerOptions"
      @change="loadData"
    ></el-date-picker>
    <peixun type="18" style="display:inline-block;margin-left:10px;position:relative;top:2px;"></peixun>
    <el-alert
      title="2018年11月14号之前的数据无法查看详情（已删除的数据不显示，重复的数据只显示一次）       (￣ε(#￣)☆╰╮o(￣皿￣///)"
      type="info"
    ></el-alert>
    <el-table
      :data="tableData"
      border
      :default-sort="{ prop: '部门', order: 'ascending' }"
      size="mini"
      style="width: 100%"
      :height="tableHeight"
    >
      <el-table-column
        v-for="item in heads"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width || 110"
        :fixed="item.label == '用户' ? true : false"
        sortable
      >
        <template slot-scope="scope">
          <span
            v-if="activeFields.includes(item.prop)"
            style="color:#409eff;cursor:pointer;"
            @click="showList(scope.row, item.prop)"
            >{{ scope.row[item.prop] }}</span
          >
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <el-table v-if="tableTotal.length > 0" :data="tableTotal" border size="mini" style="width: 100%">
      <el-table-column
        v-for="item in heads"
        :key="item.prop"
        :prop="item.prop"
        :label="item.label"
        :width="item.width || 110"
      ></el-table-column>
    </el-table>
    <!-- 三分之二人选页面 -->
    <div v-if="twoThird" class="twoThird">
      <div class="closebtn" @click.stop="twoThird = false">X</div>
      <div class="radishlist-box"><radishListSimple ref="radishListSimple" :ids="radishlists" :contents="contents"></radishListSimple></div>
    </div>
    <kpiDialog ref="kpiDialog"></kpiDialog>
  </div>
</template>
<script>
import { dateRangeUtil } from './dateRangeUtil'
import kpiDialog from './kpiDialog'

const dateFormat = require('dateformat')

export default {
  components: { kpiDialog },
  data: function() {
    return {
      loading: false,
      tableData: [],
      tableTotal: [],
      heads: [
        { prop: '用户', label: '用户', width: 100 },
        { prop: '部门', label: '部门', width: 180 },
        { prop: '电话', label: '电话沟通数' },
        { prop: '有效沟通备注', label: '有效沟通备注数', width: 130 },
        { prop: '人选会面', label: '人选会面数' },
        { prop: '客户会面', label: '客户会面数' },
        { prop: '推荐', label: '推荐人选数' },
        { prop: '实际推荐', label: '实际推荐数' },
        { prop: '面试', label: '面试数' },
        { prop: '终面', label: '终面数' },
        { prop: '人选反馈', label: '人选反馈填写数', width: 130 },
        { prop: 'offer', label: 'offer数' },
        { prop: '简历', label: '新增简历数' },
        { prop: '阅读简历', label: '阅读简历数' },
        { prop: 'LIST', label: '新增LIST数' },
        { prop: '增非cc', label: '新增非cc人数', width: 120 },
        { prop: '增cc', label: '新增cc人数' },
        { prop: '新增标签', label: '新增标签数' },
        { prop: '删除标签', label: '删除标签数' },
        { prop: '修改标签', label: '修改标签数' },
        { prop: '薪酬填写', label: '薪酬填写数' },
        { prop: '核心标签', label: '核心标签填写数', width: 130 },
        { prop: '参与项目', label: '参与项目数' },
        { prop: '活跃项目', label: '活跃项目数' },
        { prop: 'Mapping', label: 'Mapping数' },
        { prop: '变动', label: '变动数' },
        { prop: '意向诉求', label: '意向诉求填写数', width: 130 },
        { prop: 'BD-Leads', label: 'BD-Leads数', width: 120 },
        { prop: '重点推荐', label: '重点推荐数' },
        { prop: '到岗', label: '到岗数' },
        { prop: '协会绑定', label: '协会绑定数' },
        { prop: '微信', label: '微信数' },
        { prop: 'downloadfile', label: '下载文件数' },
        {
          label: 'BD-CALL',
          prop: 'BD-CALL',
        },
        {
          label: '客户沟通备注',
          prop: '客户沟通备注',
          width: 130
        },
        {
          label: 'BD-成功',
          prop: 'BD',
        },
        {
          label: '独家项目',
          prop: '独家项目',
        },
        {
          label: '高端职位',
          prop: '高端项目',
        },
        {
          label: '客户反馈',
          prop: '客户反馈',
        },
        {
          label: '签约',
          prop: '签约',
        },
        {
          label: '新建项目',
          prop: '新建项目',
        },
        {
          label: '项目对接',
          prop: '项目对接',
        },
        {
          label: '成功项目',
          prop: '成功项目',
        },
        {
          label: '分享',
          prop: '分享',
        },
        {
          label: '口碑',
          prop: '人选评分',
        },
        {
          label: '阿尔法认知',
          prop: '阿尔法认知',
        },
        {
          label: '职能模块认知',
          prop: '职能模块认知',
          width: 120
        }
      ],
      daterange: [],
      pickerOptions: {
        shortcuts: [
          {
            text: '今天',
            onClick(picker) {
              const start = new Date(new Date(new Date().toLocaleDateString()).getTime())
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '昨天',
            onClick(picker) {
              const start = new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000)
              const end = new Date(new Date(new Date().toLocaleDateString()).getTime() - 1)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本周',
            onClick(picker) {
              const range = dateRangeUtil.getCurrentWeek()
              picker.$emit('pick', range)
            },
          },
          {
            text: '上周',
            onClick(picker) {
              const range = dateRangeUtil.getPreviousWeek()
              picker.$emit('pick', range)
            },
          },
          {
            text: '本月',
            onClick(picker) {
              const range = dateRangeUtil.getCurrentMonth()
              picker.$emit('pick', range)
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const range = dateRangeUtil.getPreviousMonth()
              picker.$emit('pick', range)
            },
          },
          {
            text: '本年',
            onClick(picker) {
              const range = dateRangeUtil.getCurrentYear()
              picker.$emit('pick', range)
            },
          },
          {
            text: '去年',
            onClick(picker) {
              const range = dateRangeUtil.getPreviousYear()
              picker.$emit('pick', range)
            },
          },
        ],
      },
      radishlists: [],
      contents: [],
      twoThird: false,
      activeFields: [
        '人选评分',
        '电话',
        '有效沟通备注',
        '微信',
        '协会绑定',
        'Mapping',
        'offer',
        '面试',
        '终面',
        '推荐',
        '到岗',
        'BD-Leads',
        '变动',
        'BD',
        'LIST',
        '简历',
        '阅读简历',
        'downloadfile',
        '新增标签',
        '删除标签',
        '修改标签',
        '增cc',
        '增非cc',
        '参与项目',
        '活跃项目',
        '人选会面',
        '客户会面',
        '实际推荐', '重点推荐', '人选反馈',
        '意向诉求', '薪酬填写', '核心标签',
        '客户沟通备注', '阿尔法认知', '职能模块认知',
      ],
      detailHeads: {
        biaoqian: [
          {
            label: '人选',
            prop: '人选',
          },
          { label: '标签', prop: 'field' },
          { label: '日期', prop: '日期' },
        ],
        canyu: [
          { label: '客户公司', prop: '客户公司' },
          { label: '部门', prop: '部门' },
          { label: '项目名称', prop: '项目名称' },
        ],
        huoyue: [
          { label: '客户公司', prop: '客户公司' },
          { label: '部门', prop: '部门' },
          { label: '项目名称', prop: '项目名称' },
        ],
      },
    }
  },
  computed: {
    start() {
      if (this.daterange) {
        return Date.parse(this.daterange[0])
      } else {
        return new Date().getTime()
      }
    },
    end() {
      if (this.daterange) {
        const year = this.daterange[1].getFullYear()
        const month = this.daterange[1].getMonth()
        const day = this.daterange[1].getDate()
        const time = new Date(year, month, day, '23', '59', '59').getTime()
        return time
      } else {
        return new Date().getTime()
      }
    },
    tableHeight() {
      return document.documentElement.clientHeight - 200
    }
  },
  mounted() {
    const range = dateRangeUtil.getCurrentWeek()
    this.daterange = range
    this.loadData()
  },
  methods: {
    async showList(row, type) {
      const result = await app.service('company').getKpiList({
        start: this.start,
        end: this.end,
        user: row.用户,
        type,
      })
      if (result.status === 200) {
        if (result.type === 'radish') {
          this.radishlists = result.data
          this.contents = result.contents
          this.twoThird = true
        } else {
          this.$refs.kpiDialog.open({
            table: result.data,
            heads: this.detailHeads[result.type],
            type: result.type,
            title: `${row['用户']}的${type}KPI`,
            subType: type // 推荐
          })
        }
      } else {
        console.log(result)
      }
    },
    loadData: async function() {
      this.loading = true
      const res = await app.service('misc').listKpi({ start: this.start / 1000, end: this.end / 1000 })
      // console.log(res)
      if (res.status == 'success') {
        this.tableData = res.data
        if (res.data.length > 1) {
          this.tableTotal = [res.total]
        } else {
          this.tableTotal = []
        }
      }
      this.loading = false
    },
    handleCopy(e) {
      e.stopPropagation()
    },
  },
}
</script>
<style scoped>
.twoThird {
  position: absolute;
  top: 60px;
  right: 0;
  width: 66vw;
  height: calc(100vh - 60px);
  padding-left: 10px;
  background-color: #fff;
  border: 1px solid #eee;
  box-shadow: -3px 4px 8px 0 rgba(232, 237, 250, 0.6), 0 2px 4px 0 rgba(232, 237, 250, 0.5);
  z-index: 1002;
  padding: 25px 0 20px 0;
  overflow: auto;
}
.closebtn {
  width: 28px;
  height: 28px;
  color: #fff;
  background-color: #ff7c8c;
  border-radius: 50%;
  position: absolute;
  top: 2px;
  right: 10px;
  z-index: 4;
  line-height: 28px;
  text-align: center;
  cursor: pointer;
}
.radishlist-box {
  width: 100%;
  max-height: 100%;
  overflow: auto;
}
</style>
